import React, { useEffect, useMemo, useState } from "react";
import { getData } from "../../../services/library";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import MaterialReactTable from "material-react-table";
import { Container, IconButton, Tooltip, Typography } from "@mui/material";
import Navbar from "../../Navbar";
import StoreIcon from '@mui/icons-material/Store';
import VerChoferes from "./choferes/VerChoferes";
import Person3Icon from '@mui/icons-material/Person3';

function SucursalesHabilitadas() {
  const [sucursales, setSucursales] = useState();
  const [tabla, setTabla] = useState(true);
  const [verChoferes, setVerChoferes] = useState(false)
  const [dataRow, setDataRow] = useState()


  const obtenerSucursales = () => {
    getData("/sucursales/xsucauth/"+localStorage.getItem("suc_auth").split(","), setSucursales);
  };

  useEffect(() => {
    obtenerSucursales()
  }, [tabla])
  
  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "nombre", //access nested data with dot notation
        header: "Sucursal",
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
        // maxSize: 5, //set custom width
      },
    },
  };

  return (
    <>
        {tabla && (
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
      <Navbar />
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={sucursales ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false} //deshabilita las acciones POR COLUMNA
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            displayColumnDefOptions={displayColumnDefOptions}
            enableColumnResizing={true}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                // backgroundColor:
                //   row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                color: "black",
                // borderColor: "black",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                
                <Typography variant="poster" fontSize={26}>
                  <StoreIcon sx={{ fontSize: 20 }} />
                  Sucursales para Rendiciones Extendidas
                </Typography>
              </>
            )}
             renderRowActions={({ row }) => (
              <Tooltip arrow placement="right" title="Ver Choferes Habilitados">
                <IconButton
                  onClick={() => {
                    setDataRow(row.original);
                    setTabla(false)
                    setVerChoferes(true);
                  }}
                  color="primary"
                >
                  <Person3Icon />
                </IconButton>
              </Tooltip>
            )}
            
          />
        </Container>
        )}
        {verChoferes && (
            <VerChoferes
            sucursal={dataRow}
            onBack={()=>{
                setVerChoferes(false);
                setTabla(true)
            }}
            />
        )}
    </>
  );
}

export default SucursalesHabilitadas;
